/* this file is transformed by vux-loader */
/* eslint-disable */
import _regenerator from "E:/pm-ningde/ppos-web-propertyManage/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/pm-ningde/ppos-web-propertyManage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Tab from "vux/src/components/tab/tab.vue";
import TabItem from "vux/src/components/tab/tab-item.vue";
import LoadMore from "@/components/LoadMore";
import Xhead from "@/components/XHeader";
import bus from "@/utils/bus";
import NoData from "@/components/NoData";
import BottomNav from "@/components/BottomNav";
import { workOrderList } from "@/api/exammine";
export default {
  components: {
    Tab: Tab,
    TabItem: TabItem,
    "v-scllo": LoadMore,
    NoData: NoData,
    Xhead: Xhead,
    BottomNav: BottomNav
  },
  data: function data() {
    return {
      title: "工单审核",
      list: [],
      num: [],
      items: [{
        name: "待我审核的",
        id: "0"
      }, {
        name: "我已审核的",
        id: "1"
      }],
      // ****下拉加载相关
      loadingText: "上拉加载 ...",
      status: 0,
      page: 1,
      pagesize: 10,
      total_page: -1
    };
  },
  created: function created() {
    var _this = this;
    this.$nextTick(function () {
      _this.status = _this.$route.query.status || 0;
      _this.getWorkOrderList();
    });
  },
  methods: {
    handler: function handler(status) {
      this.page = 1;
      this.list = [];
      this.total_page = -1;
      this.status = status;
      bus.$emit("infiniteLoading", false);
      this.getWorkOrderList();
    },
    // 获取列表
    getWorkOrderList: function getWorkOrderList(done) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var param, _yield$workOrderList, list, total, showFooter;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              param = {
                page: _this2.page,
                size: _this2.pagesize,
                status: _this2.status
              };
              _context.n = 1;
              return workOrderList(param);
            case 1:
              _yield$workOrderList = _context.v;
              list = _yield$workOrderList.list;
              total = _yield$workOrderList.total;
              _this2.num[_this2.status] = total;
              _this2.total_page = total;
              if (!(Math.ceil(_this2.total_page / _this2.pagesize) < _this2.page)) {
                _context.n = 2;
                break;
              }
              _this2.loadingText = "已经没有更多了";
              return _context.a(2);
            case 2:
              _this2.list = _this2.list.concat(list);
              _this2.page++;
              _this2.loadingText = "上拉加载 ...";
              showFooter = {
                total_page: _this2.total_page,
                page_size: _this2.pagesize
              };
              bus.$emit("showFooter", showFooter);
            case 3:
              if (done) {
                done();
              }
            case 4:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    // 下拉刷新 必须存在
    onRefresh: function onRefresh() {},
    // 上拉加载
    onInfinite: function onInfinite(done) {
      this.getWorkOrderList(done);
    },
    // 跳转详情
    detailClick: function detailClick(related_no) {
      var routerParam = {
        name: "ExamineDetail",
        query: {
          related_no: related_no,
          status: this.status
        }
      };
      this.$router.push(routerParam);
    }
  }
};